import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";

export default function Loading() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return isLoading ? (
    <Box sx={{ textAlign: "center", my: 1, mx: "auto", width: "100%" }}>
      <CircularProgress />
      {/* <Box
        sx={{
          color: "#8692A6",
          fontSize: 14,
          mx: "auto",
          width: "100%",
          textAlign: "center",
          display: { xs: "none", lg: "block" },
        }}
      >
        Loading...
      </Box> */}
    </Box>
  ) : null;
}
